export const HIDE_SNACKBAR = '@@snackbar/HIDE_SNACKBAR';



// WEBPACK FOOTER //
// ./src/constants/snackbar.js